export const getTranslate = (x, y, scaleX = 1, scaleY = 1) => {
  return `translate (${x},${y}) scale(${scaleX},${scaleY})`;
};



// WEBPACK FOOTER //
// ./src/utils/scout-util.js